var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSber(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 23,
    viewBox: "0 0 132 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6667_474975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0686 4.58716C19.5743 5.2568 20.0024 5.98431 20.3442 6.75507L10.6476 14.0765L6.59509 11.4745V8.34419L10.6476 10.9462L19.0686 4.58716Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45926 11.2532C2.45926 11.1127 2.4626 10.9732 2.46929 10.8344L0.0133753 10.7112C0.0050162 10.891 2.96786e-06 11.0725 2.96786e-06 11.2557C-0.00104196 12.6872 0.273846 14.1047 0.808904 15.427C1.34396 16.7494 2.12865 17.9506 3.11796 18.9616L4.86 17.1781C4.09846 16.4012 3.49433 15.4778 3.08233 14.461C2.67033 13.4442 2.45858 12.354 2.45926 11.2532Z",
    fill: "url(#paint0_linear_6667_474975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6453 2.86857C10.7824 2.86857 10.9186 2.87371 11.054 2.88056L11.1769 0.364169C11.0009 0.355607 10.8236 0.351326 10.6453 0.351326C9.24714 0.34958 7.86246 0.630735 6.57069 1.17865C5.27891 1.72656 4.10554 2.53044 3.11792 3.54413L4.85996 5.32846C5.61846 4.54818 6.52006 3.92916 7.51292 3.50701C8.50579 3.08485 9.57029 2.86788 10.6453 2.86857Z",
    fill: "url(#paint1_linear_6667_474975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6452 19.638C10.5082 19.638 10.3719 19.638 10.2357 19.6268L10.1128 22.1424C10.2894 22.1515 10.4669 22.1561 10.6452 22.1561C12.0429 22.1576 13.4269 21.8762 14.718 21.3282C16.009 20.7801 17.1817 19.9761 18.1685 18.9624L16.4298 17.179C15.6712 17.9588 14.7697 18.5775 13.777 18.9995C12.7843 19.4215 11.72 19.6385 10.6452 19.638Z",
    fill: "url(#paint2_linear_6667_474975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2597 4.33172L17.3294 2.76914C15.4377 1.20011 13.0763 0.345986 10.6421 0.350358V2.86846C12.2904 2.86637 13.9005 3.3766 15.2597 4.33172Z",
    fill: "url(#paint3_linear_6667_474975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.29 11.2534C21.2913 10.5984 21.2354 9.94443 21.1228 9.29956L18.8316 11.0291C18.8316 11.1036 18.8316 11.1781 18.8316 11.2534C18.8322 12.425 18.5924 13.5836 18.1279 14.6541C17.6633 15.7246 16.9843 16.6832 16.1349 17.4678L17.7875 19.3386C18.8918 18.3175 19.7742 17.0701 20.3776 15.6773C20.981 14.2844 21.2918 12.7772 21.29 11.2534Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6455 19.6384C9.50164 19.6388 8.37045 19.3931 7.32514 18.9173C6.27989 18.4415 5.34382 17.7461 4.57758 16.8762L2.75195 18.5681C3.74874 19.6994 4.96654 20.6034 6.32638 21.2216C7.68622 21.8397 9.15771 22.1582 10.6455 22.1564V19.6384Z",
    fill: "url(#paint4_linear_6667_474975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.15592 5.03903L3.50416 3.16821C2.39955 4.18913 1.51679 5.43647 0.913118 6.82932C0.309451 8.22216 -0.00164581 9.72943 6.54783e-06 11.2534H2.45926C2.45876 10.0819 2.69855 8.92329 3.16309 7.85276C3.62764 6.78226 4.30658 5.82363 5.15592 5.03903Z",
    fill: "url(#paint5_linear_6667_474975)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5387 6.58564L61.4411 4.31323H51.7273V17.9684H61.4411V15.696H54.499V12.1982H60.4209V9.92583H54.499V6.58564H58.5387Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1912 9.63258H41.8188V6.58449H47.2011L50.1017 4.30518H39.0487V17.9604H44.8345C48.0783 17.9604 49.94 16.398 49.94 13.6732C49.94 11.0664 48.2538 9.63258 45.1912 9.63258ZM44.7097 15.6872H41.8188V11.9036H44.7097C46.4642 11.9036 47.2868 12.5376 47.2868 13.7954C47.2868 15.0532 46.4115 15.6872 44.7097 15.6872Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5815 4.31104H63.2939V17.9662H66.0653V14.0979H68.5815C71.955 14.0979 74.0419 12.2114 74.0419 9.19718C74.0419 6.183 71.955 4.31104 68.5815 4.31104ZM68.523 11.8238H66.0653V6.58518H68.523C70.2975 6.58518 71.2768 7.51598 71.2768 9.20551C71.2768 10.895 70.2975 11.8238 68.523 11.8238Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8897 14.7436C34.1738 15.1556 33.3716 15.369 32.5576 15.3639C30.121 15.3639 28.3534 13.5153 28.3534 10.9698C28.3534 8.42418 30.121 6.57157 32.5576 6.57157C33.4363 6.55571 34.2967 6.83886 35.0132 7.37971L36.9519 5.86244L36.8207 5.76345C35.6899 4.70684 34.1789 4.14722 32.4493 4.14722C30.5733 4.14722 28.8723 4.81795 27.6577 6.03821C27.0436 6.6665 26.558 7.42258 26.2309 8.25924C25.904 9.09591 25.7426 9.99518 25.7571 10.901C25.7441 11.8161 25.9047 12.7246 26.2293 13.5722C26.5539 14.4199 27.0358 15.1893 27.6464 15.8346C28.8665 17.1034 30.5638 17.8024 32.4265 17.8024C34.3727 17.8024 36.0738 17.0811 37.2256 15.768L35.4903 14.3942L34.8897 14.7436Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0312 9.63258H81.6602V6.58449H88.9045V4.30518H78.8882V17.9604H84.6666C87.9101 17.9604 89.7719 16.398 89.7719 13.6732C89.7794 11.0664 88.0936 9.63258 85.0312 9.63258ZM84.5497 15.6872H81.6602V11.9036H84.5497C86.3041 11.9036 87.1262 12.5376 87.1262 13.7954C87.1262 15.0532 86.2588 15.6872 84.5497 15.6872Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.281 17.9411H118.471V4.28589H121.281V10.0212H122.81L126.94 4.28589H130.124L125.226 10.7818L130.914 17.9411H127.186L123.005 12.5706H121.281V17.9411Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9799 15.3458H94.0362L93.0286 17.9974H90.0385L95.6133 4.34229H98.6027L104.087 17.9974H100.988L99.9799 15.3458ZM99.049 12.8716L97.0256 7.56818L94.991 12.8716H99.049Z",
    fill: "#21A038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.87 4.34229V10.0444H113.684V4.34229H116.581V17.9974H113.684V12.6168H107.87V17.9974H104.973V4.34229H107.87Z",
    fill: "#21A038"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6667_474975",
    x1: 3.61533,
    y1: 18.6474,
    x2: 0.811392,
    y2: 10.7339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6667_474975",
    x1: 3.82008,
    y1: 3.98935,
    x2: 10.7819,
    y2: 1.39917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6667_474975",
    x1: 9.95066,
    y1: 20.6363,
    x2: 17.7943,
    y2: 18.9063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6667_474975",
    x1: 10.1306,
    y1: 1.19372,
    x2: 16.8485,
    y2: 3.21773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6667_474975",
    x1: 3.36885,
    y1: 18.2616,
    x2: 10.6934,
    y2: 20.9341,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6667_474975",
    x1: 0.916165,
    y1: 11.5582,
    x2: 3.96373,
    y2: 3.81825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6667_474975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 22,
    fill: "white",
    transform: "translate(0 0.350342)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSber);
export default __webpack_public_path__ + "static/media/sber.2dceac89e07309bce15455562b06344c.svg";
export { ForwardRef as ReactComponent };